<div class="card">
    <!-- <p-toolbar styleClass="mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="Novo" icon="pi pi-plus" class="p-button-success mr-2"
                (click)="openNew()"></button>
        </ng-template>

        <ng-template pTemplate="right">
            <div class="flex">
                <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()"
                    class="p-button-success mr-2" pTooltip="XLS" tooltipPosition="bottom"></button>
                <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()"
                    class="p-button-warning mr-2" pTooltip="PDF" tooltipPosition="bottom"></button>
            </div>
        </ng-template>
    </p-toolbar> -->

    <p-table #dt [value]="data" [rows]="20" styleClass="p-datatable-gridlines p-datatable-responsive-demo"
        [paginator]="true" [rowHover]="true" dataKey="id"
        currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} registros" [showCurrentPageReport]="true"
        [globalFilterFields]="['id','descricao','cliente.nome']">


        <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between">
                <h5 class="p-m-0">Tipos de Descodificadores</h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="Pesquisar..." />
                </span>
            </div>

        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th>Código
                </th>
                <th>Descrição
                </th>
                <th>Nome Função
                </th>
                <!-- <th>Editar</th> -->

            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-dt>
            <tr>
                <td><span class="p-column-title negrito">Código: </span>{{dt.id}}</td>

                <td><span class="p-column-title negrito">Descrição: </span>{{dt.descricao}}</td>
                <td><span class="p-column-title negrito">Nome Função: </span>{{dt.nome_funcao}}</td>


                <!-- <td style="text-align: center;">
                    <span class="p-column-title negrito">Editar: </span>
                    <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-primary mr-2"
                        (click)="edit(dt)"></button>
                </td> -->



            </tr>
        </ng-template>

    </p-table>
</div>

<!-- <p-dialog header="Estação" [(visible)]="displayModal" [modal]="true" [breakpoints]="{'960px': '75vw'}" [style]="{width: '50vw'}" [baseZIndex]="10000"
    [draggable]="false" [resizable]="false">
    <div [ngStyle]="{'margin': '7px'}">
        <form [formGroup]="form" class="p-fluid grid">

            <div class="field col-12 md:col-12 xl:col-12">
                <input type="checkbox" class="form-check-input" id="ativo" formControlName="ativo">
                <label class="form-check-label" for="ativo">Ativo</label>
            </div>

            <div class="field col-12 md:col-12 xl:col-12">
                <p-floatlabel>
                    <input type="text" id="descricao" pInputText formControlName="descricao">
                    <label for="descricao">Descrição</label>
                </p-floatlabel>
            </div>

            <div class="field col-12 md:col-12 xl:col-8" style="margin-top: 28px;">
                <p-floatlabel>
                        <p-autoComplete formControlName="cliente_id" [forceSelection]="true"
                            [suggestions]="clientesFiltrados" appendTo="body" (completeMethod)="filtrarClientes($event)"
                            field="label">
                        </p-autoComplete>
                        <label for="cliente_id">Cliente</label>
                    </p-floatlabel>
            </div>
            <div class="field col-12 md:col-12 xl:col-4">
                <label for="data_instalacao">Data da instalação</label>
                    <input type="date" id="data_instalacao" pInputText formControlName="data_instalacao">
                    
                
            </div>
            <div class="field col-12 md:col-12 xl:col-12">
                <p-floatlabel>
                    <input type="text" id="localizacao" pInputText formControlName="localizacao">
                    <label for="localizacao">Localizacao</label>
                </p-floatlabel>
            </div>
            
            <div class="field col-12 md:col-12 xl:col-3">
                <p-floatlabel>
                    <input type="text" id="latitude" pInputText formControlName="latitude">
                    <label for="latitude">Latitude</label>
                </p-floatlabel>
            </div>
            <div class="field col-12 md:col-12 xl:col-3">
                <p-floatlabel>
                    <input type="text" id="longitude" pInputText formControlName="longitude">
                    <label for="longitude">Longitude</label>
                </p-floatlabel>
            </div>
            <div class="field col-12 md:col-12 xl:col-3">
                <p-floatlabel>
                    <input type="text" id="tipo_integracao" pInputText formControlName="tipo_integracao">
                    <label for="tipo_integracao">Tipo integração</label>
                </p-floatlabel>
            </div>
            <div class="field col-12 md:col-12 xl:col-2">
                <p-floatlabel>
                    <input type="text" id="plu" pInputText formControlName="plu">
                    <label for="plu">PLU</label>
                </p-floatlabel>
            </div>
            <div class="field col-12 md:col-12 xl:col-2">
                <p-floatlabel>
                    <input type="text" id="flu" pInputText formControlName="flu">
                    <label for="flu">FLU</label>
                </p-floatlabel>
            </div>
            
        </form>
    </div>
        <ng-template pTemplate="footer">
            <button pButton pRipple type="button" icon="pi pi-arrow-left" (click)="displayModal = false" label="Voltar"
                    class="p-button-raised p-button-warning mr-2">
                </button>
            <button *ngIf="loading == false" pButton pRipple type="button" icon="pi pi-check" (click)="save()"
            label="Salvar" class="p-button-raised p-button-success"></button>
        <p-progressSpinner *ngIf="loading" [style]="{width: '50px', height: '50px'}" styleClass="custom-spinner"
            strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
        </ng-template>
</p-dialog> -->
